module.exports = __webpack_public_path__ + "static/media/A2GLogoApp.13300733.png";